import type { Resource } from '../../';
export const cart_cartItem_addToWishList: Resource = {"default":"Add to Wish List"};
